import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BannerComponent } from '@components';

import { ViguideRecommendationsStore } from '@store';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  standalone: true,
  imports: [CommonStandaloneModule, MatCardModule, MatIconModule, BannerComponent, MatDialogModule],
  selector: 'app-optimization-overlay',
  templateUrl: './optimization-overlay.component.html',
  styleUrls: ['./optimization-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptimizationOverlayComponent {
  constructor(
    public viguideRecommendationsStore: ViguideRecommendationsStore,
    public dialogRef: MatDialogRef<OptimizationOverlayComponent>
  ) {}
}
